import React, {useState, useEffect} from 'react'
import B2bPurchase from 'containers/purchase/partials/b2b_purchase'
import B2cPurchase from 'containers/purchase/partials/b2c_purchase'
import B2cWidePurchase from 'containers/purchase/partials/b2c_wide_purchase'
import {get} from 'lodash'

const ProductPurchase = (props) => {
  const {user, product_id, endpoints, product, related_products, cart_params} = props

  const saleChannelTarget = get(user, 'user.sale_channel_target', 'b2b')
  const themeCode = get(user, 'user.theme.code')
  const layout = get(product, 'external_api_config.layout', 'side')

  // if (saleChannelTarget == 'b2c') {
  //   return <B2cPurchase {...props}/>
  // }

  if (themeCode == 'indestinum') {
    if (layout == 'wide') {
      return <B2cWidePurchase {...props}/>
    } else {
      return <B2cPurchase {...props}/>
    }
  }

  if (themeCode == 'goforajourney') {
    return <B2cPurchase {...props}/>
  }

  return <B2bPurchase {...props}/>
}

export default ProductPurchase
